import { IconCircleCheckFilled, IconProps } from '@tabler/icons-react'

import IconWrapper from './IconWrapper'

const CheckmarkIcon = (props: IconProps) => {
	return <IconWrapper icon={IconCircleCheckFilled} {...props} />
}

export default CheckmarkIcon
